import React from 'react';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';

const CreateAction = ({ onClick, url, disabled }) => (
  <RibbonMenu
    name="save"
    icon="plus"
    message="actions.new"
    onClick={onClick}
    url={url}
    className="aridhia-create-action"
    disabled={disabled}
  />
);

export default CreateAction;
